import React, { FC, useState } from "react";
import styled from "styled-components";
import { ExpertText, SmallText } from "../../../../Components/Text3D";
import { Row, Upload, Col, Space, Spin } from "antd";
import { useMutation } from "@apollo/client";
import { uploadtoS3 } from "../../../../Api/fileUpload";
import { GENERATE_PRE_SIGNED_URL_MUTATION } from "../../../../Apollo/graphql/Mutation/UploadFile";
import UploadImg from '../../../../assets/images/uploadImg.png';
// import logo from '../../ ../assets/images/logo.png';
import { Link, useHistory } from "react-router-dom";

const { Dragger } = Upload;

const MainContainer = styled(Row)`
  /* &:before {
    content: "";
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid white;
    margin-left: 35rem;
  } */
`;
const SelectContent = styled(Link)`
    display: flex;
    border: 1px solid #1196dd;
    height: 60px;
    align-items: center;
    padding: 0 2rem;
`

const ContentDiv = styled(Col)`
  background-color: white;
  font-family:"Rogan";
  width: 100%;
  padding-bottom: 2rem;
`;
const ContentSection = styled.div`
  margin: 2rem 0;
`;
const StyledDiv = styled.div`
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
`;
const DragSection = styled(Dragger)`
  background: white;
  justify-content: center;
  border: none;
`;
interface IProps {
    hasSTL?: boolean
}
const ImgDiv = styled.div<IProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #1196dd;
  box-sizing: border-box;
  height: ${props => props.hasSTL ? '300px' : '116px'};
  width: ${props => props.hasSTL ? 'auto' : '116px'};
  margin: 0 auto;
`;

const Estimate: FC = () => {
    const history = useHistory()
    const [uploadUrl, setUploadUrl] = useState("");
    const [uploadFileMutation] = useMutation(GENERATE_PRE_SIGNED_URL_MUTATION);
    const [loading, setLoading] = useState(false);

    const props = {
        name: "file",
        multiple: false,
        beforeUpload: async (file: any) => {
            setLoading(true);
            try {
                const {
                    data: {
                        generate3dPreSignedURL: { url },
                    },
                } = await uploadFileMutation({
                    variables: {
                        input: {
                            type: "put",
                            fileId: file.uid,
                            mime: file.name.includes(".stl") ? "model/stl" : file.type,
                        },
                    },
                });
                
                if (url) {
                    uploadtoS3(url, file)
                        .then((data) => {
                            setUploadUrl(url.split("?")[0]);
                            setLoading(false);
                            history.push("/designs/quantity")
                        })
                        .catch((err) => {
                            console.log("Error: ", err);
                            setLoading(false);
                        });
                }
            } catch (err) {
                console.log("ERRROR", err);
                setLoading(false);
            }
            return false;
        },
    };
    return (
        <Spin spinning={loading}>
            <MainContainer>
                <ContentDiv span={20} offset={2}>
                    <Col style={{ display: 'flex', flexDirection: 'column' }}>
                        <Space style={{ margin: '2rem 0' }}>
                            <SmallText>Select from Marketplace</SmallText>
                        </Space>
                        <SelectContent to="/marketplace">
                            <SmallText>Click to select the design</SmallText>
                        </SelectContent>
                    </Col>
                    <ContentSection>
                        <h1 style={{ textAlign: 'center' }}>upload the file</h1>
                        <StyledDiv>
                            <DragSection
                                {...props}
                                accept=".stl"
                                style={{ background: "white", border: 'none' }}
                            >
                                <ImgDiv>
                                    <img
                                        src={uploadUrl ? uploadUrl : UploadImg}
                                        alt=""
                                    />
                                </ImgDiv>
                                <SmallText style={{ paddingBottom: ".5rem", marginTop: '2rem' }}>
                                    <span>Upload files & other formats.</span>
                                </SmallText>
                                <ExpertText dark>(Drag or click to upload)</ExpertText>
                            </DragSection>
                        </StyledDiv>
                    </ContentSection>
                </ContentDiv>
            </MainContainer>
        </Spin>
    );
};

export default Estimate;